import $ from 'jquery';
import { addToBag } from './add-to-bag';

export default function setUpBisAndSo(){
    if(!window.rcProps || !window.rcProps.pdp ||!window.rcProps.pdp.isBisPage) return;

    $('select[name="size"]').change(function(e){
        // $('#so-email').focus();
        var el = $(this).find('option:selected');
        var $form = $(this).parents('form');
        var $emailField = $form.find('.js-email-div');
        var instock = el.data('instock');
        var preorder = el.data('preorder');
        var fwrdInstock = el.data('fwrd');
        const fwrdPreorder = el.data('fwrdPreorder');
        var eligibleForSpecialOrder = el.data('eligibleForSpecialOrder');
        var isSpecialOrderForm = $(this).attr('id') === 'so-size'
        $('.bis-notification').hide();
        $('.so-msg-bis-pending').addClass('u-hide');
        $('.js-bis-details').show();
        $('.js-so-details').show();
        $form.find('.js-bis_so-fwrd-link').hide();
        if(instock){
            $form.find('.js-notification-instock').show();
            $form.find('.notify-me__cta button').hide();
            const $emailInput = $emailField.find('input');
            $emailField.hide();
            $('#bis-email-opt-in').hide();
            $('#so-email').val('');
            $form.find('.notify-me__auto-order').hide();
            $form.find('.js-add-to-bag').show();
        } else if (fwrdInstock || fwrdPreorder) {
            setTimeout(() => {
                $form.find('.js-email-div').hide();
                $form.find('.notify-me__cta button').hide();
                $form.find('.notify-me__auto-order').hide();
                $('.js-bis-details').hide();
                $('.js-so-details').hide();
                if (fwrdPreorder) {
                    $('.fwrd-preorder-cta').removeClass('u-hide');
                    $('.fwrd-shop-cta').addClass('u-hide');
                } else {
                    $('.fwrd-preorder-cta').addClass('u-hide');
                    $('.fwrd-shop-cta').removeClass('u-hide');
                }
                $form.find('.js-bis_so-fwrd-link').show();
                $form.find('.js-notify-me').hide();

            }, "100");
        } else if(preorder){
            $form.find('.js-notification-preorder').show();
            $form.find('.notify-me__cta button').hide();
            $emailField.show();
            $('#bis-email-opt-in').show();
            $form.find('.notify-me__auto-order').show();
            $form.find('.js-notify-me').show();
        }else if(isSpecialOrderForm && !eligibleForSpecialOrder){
            $form.find('.js-notification-unavailable').show();
            $form.find('.notify-me__cta button').hide();
            $emailField.show();
            $('#bis-email-opt-in').show();
            $form.find('.notify-me__auto-order').show();
            $form.find('.js-special-order').show();
        }else{
            $form.find('.notify-me__cta button').hide();
            $emailField.show();
            $('#bis-email-opt-in').show();
            $form.find('.notify-me__auto-order').show();
            if(isSpecialOrderForm){
                $form.find('.js-special-order').show();
            }else{
                $form.find('.js-notify-me').show();
            }
        }
    });

    $('.js-bis_so-fwrd-btn').on('click', function(event) {
        event.preventDefault();
        const $this = $(this);
        const sizeType = $this.data('sizeType');
        let selectedSize;
        if (sizeType == 'so') {     // special order
            selectedSize = $('#so-size');
        } else {
            selectedSize = $('#bis-size');  //back in stock
        }
        if (selectedSize.length > 0) {
            const sizeValue = selectedSize.val();
            const productCode = $this.data('code');
            const baseURL = $this.data('href');
            const dynamicUrl = baseURL + '&size=' + sizeValue + '&code=' + productCode;
            window.open(dynamicUrl, '_blank');
        }
    });

    $('#nav-go-back-btn a, .confirmation__btn').click(function(e){
        e.preventDefault();
        var code = $('.notify-me__form').find(':input[name="code"]').val();
        var dept = $('.notify-me__form').find(':input[name="dept"]').val();
        location.href='/r/mobile/DisplayProduct.jsp?product='+code +'&d='+dept;
    });
    $('#notify-me-form').submit(function(e){
        e.preventDefault();
        var $form = $(this);
        var size = $form.find(':input[name="size"]').val();
        var email = $form.find(':input[name="email"]').val();
        var errors = false;
        if(size === '') {
          $('#bis-size-error').closest('.field').addClass('is-error');
          errors = true;
        } else {
          $('#bis-size-error').closest('.field').removeClass('is-error');
        }
        if(email === '') {
          $('#bis-email-error').closest('.field').addClass('is-error');
          errors = true;
        } else {
          $('#bis-email-error').closest('.field').removeClass('is-error');
        }
        if(errors === true && !isAddToBag($form)) {
          return false;
        }

        var code = $form.find(':input[name="size"] option:selected').data("code");
        if(isAddToBag($form)){
          //do add to bag
          addToBag(code, size);
        }else{
          //do notify me
          submitNotifyMe(code, size, email, function() {
              $('#main-div').hide();
              $('#bis-confirmation-email').html(email);
              var bisconfirmation = $('#bis-confirmation').detach();
              $('body').append(bisconfirmation);
              $.modal.close();
              $.modal({
                  open: "bis-confirmation",
                  triggerOpen: true
              });
          })
        }
    });

    $('#special-order-form').submit(function(e){
        e.preventDefault();
        var $form = $('#special-order-form');
        var size = $form.find(':input[name="size"]').val();
        var email = $form.find(':input[name="email"]').val();
        var errors = false;
        if(size === '') {
          $('#so-size-error').closest('.field').addClass('is-error');
          errors = true;
        } else {
          $('#so-size-error').closest('.field').removeClass('is-error');
        }
        if(email === '') {
          $('#so-email-error').closest('.field').addClass('is-error');
          errors = true;
        } else {
            $('#so-email-error').closest('.field').removeClass('is-error');
        }
        if(errors === true && !isAddToBag($form)) {
          return false;
        }
        var code = $form.find(':input[name="size"] option:selected').data("code");
        var autoOrder = $form.find('#so-auto-order').is(":checked");
        if(isAddToBag($form)){
            //do add to bag
            addToBag(code, size);
        } else if(isNotifyMe($form)){
            //do notify me
            submitNotifyMe(code, size, email, function(){
                $('#main-div').hide();
                $('#bis-confirmation-email').html(email);
                let bisconfirmation = $('#bis-confirmation').detach();
                $('body').append(bisconfirmation);
                $.modal.close();
                $.modal({
                    open: "bis-confirmation",
                    triggerOpen: true
                });
            })
        } else {
            //do special order
            var notEligible = $('.js-notification-unavailable').is(':visible');
            if(notEligible){
                submitSpecialOrder(code, size, email, autoOrder, function(){
                    submitNotifyMe(code, size, email, function(){
                        showSoConfirmation();
                    })
                });
            }else{
                submitSpecialOrder(code, size, email, autoOrder, function(result) {
                    result = $.parseJSON(result);
                    if (result.success) {
                        showSoConfirmation();
                    } else if (result.duplicate) {
                        $('.so-msg-bis-pending').removeClass('u-hide');
                    } else {
                        result.errorMsg = result.errorMsg || "Invalid Product";
                        switch (result.errorMsg) {
                            case "Invalid Product":
                                $.modal({
                                    open: "invalid-product-so-modal",
                                    triggerOpen: true,
                                    type: "toast"
                                });
                                break;
                            case "Discontinued Product":
                                $.modal({
                                    open: "discontinued-product-so-modal",
                                    triggerOpen: true,
                                    type: "toast"
                                });
                                break;
                            case "Preorder Exists":
                                $("#preorder-exists-so-modal").data("size", size).data("code", code);
                                $.modal({
                                    open: "preorder-exists-so-modal",
                                    triggerOpen: true,
                                    type: "toast"
                                });
                                break;
                            case "Instock":
                                $("#instock-so-modal").data("size", size).data("code", code);
                                $.modal({
                                    open: "instock-so-modal",
                                    triggerOpen: true,
                                    type: "toast"
                                });
                                break;
                        }
                    }
                });
            }
        }
    });

    $('.js-so-atb').on('click', function() {
        const $modal = $(this).closest(".modal");
        addToBag($modal.data("code"), $modal.data("size"));
    });
}

function isAddToBag(formObj){
    return formObj.find('.js-add-to-bag').is(':visible');
}

function isNotifyMe(formObj){
    return formObj.find('.js-notify-me').is(':visible');
}

function showSoConfirmation(){
    $('#main-div').hide();
    $('#so-confirmation').show();
    let soconfirmation = $('#so-confirmation').detach();
    $('body').append(soconfirmation);
    $.modal.close();
    $.modal({
        open: "so-confirmation",
        triggerOpen: true
    });
}

function submitNotifyMe(code, size, email, callback){
    var data = $.param({
        size : size,
        email : email,
        code : code,
        isMobile: true
    });

    $.post("/r/ajax/SubmitFindSizeInquiry.jsp", data, function(msg){
        if(callback){
            callback();
        }
    });
}

function submitSpecialOrder(code, size, email, autoOrder, callback){
    var data = $.param({
        productCode: code,
        specialSizeValueField: size,
        userEmail: email,
        autoOrderValueField: autoOrder,
        isMobile: true
    });

    $.post("/r/ajax/SubmitSpecialOrderInquiry.jsp", data, function(result) {
        if (callback) {
            callback(result);
        }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/bis-and-so.js